import React from 'react';
import { PIPELINE_CREATED_AT, PIPELINE_ID } from '../../../../config';
import { HorizontalLine } from '../../line/HorizontalLine';
import { VersionTag } from '../../version-tag';
import { FooterBottom } from './footer-bottom';
import { FooterIcon } from './footer-icon';

const LandscapeFooter: React.FC = () => {
  return (
    <footer className="pkd-footer landscape-footer">
      <div className="container mt-4 py-md-4">
        <div className="d-flex flex-column w-100 h-100">
          <FooterIcon />
        </div>

        <HorizontalLine options={{ margin: '30px 0 48px 0' }} />
        <FooterBottom />

        {PIPELINE_ID && PIPELINE_CREATED_AT && (
          <div className="position-relative">
            <VersionTag
              pipelineId={PIPELINE_ID}
              pipelineDate={PIPELINE_CREATED_AT}
              className="position-absolute text-center"
              style={{ color: '#1d1d1b' }}
            />
          </div>
        )}
      </div>
    </footer>
  );
};

export { LandscapeFooter };
